export default __webpack_public_path__ + "static/media/c1.8f28024a.png";